import { render } from "./AppSkeletonRect.vue?vue&type=template&id=f10f08bc&scoped=true&ts=true"
import script from "./AppSkeletonRect.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonRect.vue?vue&type=script&lang=ts"

import "./AppSkeletonRect.vue?vue&type=style&index=0&id=f10f08bc&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10f08bc"]])

export default __exports__